/*
* Project: LegalPlace assistant
* File: src/middlewares/count_things.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/

import { raiseVariable, raiseOption } from '../logic/action_counter';
import lpApp from '../app/lp_app';

export const countThings = store => next => (action) => {
  if (action.type == 'EDIT_VARIABLE_VALUE_' && lpApp.mutex.checkMutex('preview')) raiseVariable(action.id);
  // this one is the magic key.

  if (lpApp.mutex.checkMutex('preview')) lpApp.action_tracker.trackAction(action.type, action.id);

  next(action);
};



// WEBPACK FOOTER //
// ./src/middlewares/count_things.js